export default __webpack_public_path__ + "static/media/icn-filter-gray.7c0b8c36.svg";